export default __webpack_public_path__ + "static/set-us-apart-4-f9be7d42298ec3a16425e56c66601d14.jpg";